import { PhoneIncoming } from "lucide-react";

import BUTTON_TYPES from "@/lib/constants/buttonTypes";
import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const finalCTASection: ServiceSection = {
  type: SECTION_TYPES.FINAL_CTA,
  content: {
    header: "Get in touch",
    subheader: "We'd love to hear from you",
    showCustomButtons: false,
    buttons: [
      {
        type: BUTTON_TYPES.SITE_LINK,
        label: "Get in touch",
        link: "/contact-us",
      },
      {
        type: BUTTON_TYPES.EXTERNAL_LINK,
        label: "Find us here too",
        link: "https://google.com",
      },
    ],
  },
  meta: {
    displayName: "Call to Action",
    displayDescription: "Encourage your customers to take action.",
    displayIcon: PhoneIncoming,
    variantsCount: 6,
  },
  aiPrompt() {
    return "In the Final Call to Action section, create a sense of urgency and motivate visitors to take the desired action. Use persuasive language and highlight the benefits of taking action. Make the call-to-action button prominent and easy to find.";
  },
};

export default finalCTASection;
